import { RotationsplanFeatureState } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/types';
import { StoreContext } from '@/domain/mitarbeiter/pages/rotationsplan/overview/PageWrapper';
import { ReactNode, createContext, useContext } from 'react';
import { useStore } from 'zustand';

type RotationsplanFeatureContext = {
  store: RotationsplanFeatureState;
};

const RotationsplanFeatureContext =
  createContext<RotationsplanFeatureContext | null>(null);

export function RotationsplanFeatureProvider({
  children,
}: {
  children: ReactNode;
}) {
  const storeContext = useContext(StoreContext);
  if (!storeContext) {
    throw new Error('Missing store context');
  }
  const store = useStore(storeContext, (s) => s);
  const value = { store };

  return (
    <RotationsplanFeatureContext.Provider value={value}>
      {children}
    </RotationsplanFeatureContext.Provider>
  );
}

export function useRotationsplanFeatureContext(): RotationsplanFeatureContext {
  const rotationsplanFeatureContext = useContext(RotationsplanFeatureContext);
  if (!rotationsplanFeatureContext) {
    throw new Error('Missing rotationsplan feature context');
  }
  return rotationsplanFeatureContext;
}
